import type { BuilderContent } from '@builder.io/sdk'
import { createContext, useContext } from 'react'

import type { getAppInstallBannerCookie } from '@/legacy/components/AppInstallBanner/helpers'
import type {
  ArticleEntryData,
  BuilderBlogModel,
  CardArticleEntryData,
  ContentReview,
} from '@/legacy/models'
import type { ArticleSSRProps } from '@/pages/blog/[...slug]'

export interface BlogArticleCmsContextProps {
  article: ArticleEntryData
  adsTop: BuilderContent & Pick<ArticleSSRProps, 'adsTop'>
  adsMiddle: BuilderContent & Pick<ArticleSSRProps, 'adsMiddle'>
  adsBottom: BuilderContent & Pick<ArticleSSRProps, 'adsBottom'>
  content: BuilderContent
  data: BuilderBlogModel
  footer: BuilderContent
  model: string
  isPreview: boolean
  contentReview: ContentReview | null
  relatedArticles: CardArticleEntryData[]
  appInstallBanner: ReturnType<typeof getAppInstallBannerCookie>
}

const BlogArticleCmsContext = createContext({} as BlogArticleCmsContextProps)

interface Props {
  children: React.ReactNode
  data: BlogArticleCmsContextProps
}

export default function BlogArticleCmsProvider({ children, data }: Props) {
  return <BlogArticleCmsContext.Provider value={data}>{children}</BlogArticleCmsContext.Provider>
}

export const useBlogArticleCms = () => useContext(BlogArticleCmsContext)
